import { gql } from '@apollo/client';

const UPDATE_MORPHOLOGY = gql`
  mutation updateMorphology($input: UpdateMorphologyInput!) {
    updateMorphology(input: $input) {
      isSuccess
      message
    }
  }
`;

export default UPDATE_MORPHOLOGY;
